import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import classnames from 'classnames'
import _ from 'lodash'

import config from '../../../../../../../../../../../../../../../config'

import CloseableRow from '../../../../../../../../../../../../../../../components/CloseableRow'
import Date from '../../../../../../../../../../../../../../../components/TableCell/components/Date'
import Entity from '../../../../../../../../../../../../../../../components/TableCell/components/Entity'
import QuestionIcon from '../../../../../../../../../../../../../../../components/QuestionIcon'

import { LOCALE_PREFIX, ENDED_PROCEEDING_CODE } from './constants'
import { PRECISION } from '../../../../../../../../../../../../../../../components/TableCell/components/Date/constants'

import hocConnect from './hocConnect'

import './style.scss'

@injectIntl
@hocConnect
export default class EstateDetail extends Component {
    static propTypes = {
        block: PropTypes.string.isRequired,
        blockCustomData: PropTypes.object.isRequired,
        customData: PropTypes.object.isRequired,
        customDataRows: PropTypes.object.isRequired,
        id: PropTypes.string.isRequired,
        intl: PropTypes.object.isRequired,
        listId: PropTypes.string.isRequired,
        objectId: PropTypes.string.isRequired,
        saveCustomData: PropTypes.func.isRequired,
    }

    shouldComponentUpdate(nextProps) {
        if (this.props.id !== nextProps.id) return true
        if (this.props.block !== nextProps.block) return true
        if (this.props.listId !== nextProps.listId) return true
        if (this.props.objectId !== nextProps.objectId) return true
        if (!_.isEqual(this.props.customData, nextProps.customData)) return true
        if (!_.isEqual(this.props.customDataRows, nextProps.customData)) return true
        if (!_.isEqual(this.props.blockCustomData, nextProps.customData)) return true

        return false
    }

    onCloseableRowExpand = (newState, rowId) => {
        const { listId, objectId, blockCustomData, saveCustomData } = this.props

        saveCustomData({
            ownershipListEstateDetailRow: {
                ..._.get(blockCustomData, 'ownershipListEstateDetailRow', {}),
                [listId]: {
                    ..._.get(blockCustomData, `ownershipListEstateDetailRow.${listId}`, {}),
                    [objectId]: {
                        ..._.get(blockCustomData, `ownershipListEstateDetailRow.${listId}.${objectId}`, {}),
                        [rowId]: newState,
                    },
                },
            },
        })
    }

    onMapLinkClick = () => {
        const { customData } = this.props

        const gps = _.get(customData, 'data.address.gps', null)

        if (gps) window.open(`https://maps.google.com/?q=${gps.lat},${gps.lng}`, '_blank')
    }

    renderAddress = () => {
        const { customData, intl } = this.props

        const address = _.get(customData, 'data.address', null)

        if (!address) return null

        return (
            <div className={'estate-detail-table'}>
                <div className={'estate-detail-row'}>
                    <div className={'estate-detail-title'}>
                        {intl.formatMessage({ id: `${LOCALE_PREFIX}.title.address` })}
                    </div>
                    <div className={'estate-detail-value'}>
                        <div className={'address-wrap'}>
                            {address.full && <div className={'full-address'}>{address.full}</div>}
                            {address.gps && (
                                <div className={'map-link'} onClick={this.onMapLinkClick}>
                                    <div>{`(${intl.formatMessage({ id: `${LOCALE_PREFIX}.address.map` })}`}</div>
                                    <div className={'map-link-image'} />
                                    <div>{')'}</div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    renderCadastreWorkplace = () => {
        const { customData, intl } = this.props

        const cadastreWorkplace = _.get(customData, 'data.workplace', null)

        if (!cadastreWorkplace) return null

        return (
            <div className={'estate-detail-table'}>
                <div className={'estate-detail-row'}>
                    <div className={'estate-detail-title'}>
                        {intl.formatMessage({ id: `${LOCALE_PREFIX}.title.cadastreWorkplace` })}
                    </div>
                    <div className={'estate-detail-value'}>{cadastreWorkplace}</div>
                </div>
            </div>
        )
    }

    renderOtherEntries = () => {
        const { customData, intl } = this.props

        const otherEntries = _.get(customData, 'data.otherEntries', [])

        if (_.isEmpty(otherEntries)) return null

        // title only in first row
        return (
            <div className={'estate-detail-table'}>
                {_.map(otherEntries, (otherEntry, index) => (
                    <div key={`otherEntry_${index}`} className={'estate-detail-row'}>
                        <div className={'estate-detail-title'}>
                            {index === 0 && intl.formatMessage({ id: `${LOCALE_PREFIX}.title.otherEntries` })}
                        </div>
                        <div className={'estate-detail-value'}>{otherEntry}</div>
                    </div>
                ))}
            </div>
        )
    }

    renderSeriousRestrictionTooltip = () => {
        const { intl } = this.props

        return (
            <div className={'serious-restriction-tooltip'}>
                <div className={'serious-restriction-tooltip-title'}>
                    {intl.formatMessage({ id: `${LOCALE_PREFIX}.restriction.tooltip.title` })}
                </div>
                <div className={'serious-restriction-tooltip-text'}>
                    {intl.formatMessage({ id: `${LOCALE_PREFIX}.restriction.tooltip.text` })}
                </div>
            </div>
        )
    }

    renderRestrictions = () => {
        const { customData, id, block, listId, objectId, intl } = this.props

        const restrictions = _.get(customData, 'data.restrictions', [])

        if (_.isEmpty(restrictions)) return null

        // title only in first row
        return (
            <div className={'estate-detail-table'}>
                {_.map(restrictions, (restriction, index) => (
                    <div key={`restriction_${index}`} className={'estate-detail-row'}>
                        <div className={'estate-detail-title'}>
                            {index === 0 && intl.formatMessage({ id: `${LOCALE_PREFIX}.title.restrictions` })}
                        </div>
                        <div className={'estate-detail-value'}>
                            <div className={'restriction'}>
                                <div className={'restriction-text'}>{restriction.value}</div>
                                {restriction.important && (
                                    <QuestionIcon
                                        id={`${config.modules.report.key}_${id}_${block}_${listId}_${objectId}_${index}_serious_restriction`}
                                        character={'!'}
                                        color={'#dd3300'}
                                        text={this.renderSeriousRestrictionTooltip()}
                                    />
                                )}
                            </div>
                        </div>
                        {restriction.startDate && (
                            <div className={'estate-detail-date'}>
                                <div className={'date-wrap'}>
                                    <div className={'date-text'}>
                                        {intl.formatMessage({ id: `${LOCALE_PREFIX}.date.from` })}
                                    </div>
                                    <Date date={restriction.startDate.value} precision={PRECISION.DAY} />
                                </div>
                            </div>
                        )}
                    </div>
                ))}
            </div>
        )
    }

    renderProceedings = () => {
        const { customData, customDataRows, id, block, listId, objectId, intl } = this.props

        const proceedings = _.get(customData, 'data.proceedings', [])

        if (_.isEmpty(proceedings)) return null

        // title only in first row
        return (
            <div className={'estate-detail-table'}>
                {_.map(proceedings, (proceeding, index) => (
                    <div key={`proceed_${index}`} className={'estate-detail-row no-hover'}>
                        <div className={'estate-detail-hover'} />
                        <div className={'estate-detail-title'}>
                            {index === 0 && (
                                <div className={'proceeding'}>
                                    <div className={'proceeding-text'}>
                                        {intl.formatMessage({ id: `${LOCALE_PREFIX}.title.proceedings` })}
                                    </div>
                                    <QuestionIcon
                                        id={`${config.modules.report.key}_${id}_${block}_${listId}_${objectId}_proceeding`}
                                        text={intl.formatMessage({ id: `${LOCALE_PREFIX}.proceeding.help` })}
                                        tooltipWidth={'200px'}
                                    />
                                </div>
                            )}
                        </div>
                        <div
                            className={classnames(
                                'estate-detail-value',
                                proceeding.stateCode === ENDED_PROCEEDING_CODE && 'ended'
                            )}
                        >
                            <CloseableRow
                                id={index}
                                title={proceeding.objects}
                                expanded={_.get(customDataRows, index, false)}
                                onExpand={this.onCloseableRowExpand}
                                expandOnTitleClick
                            >
                                <div className={'estate-detail-closeable-child'}>
                                    {proceeding.number && (
                                        <div className={'estate-detail-closeable-child-row'}>
                                            <div>{intl.formatMessage({ id: `${LOCALE_PREFIX}.row.title.number` })}</div>
                                            <div>{proceeding.number}</div>
                                        </div>
                                    )}
                                    {proceeding.state && (
                                        <div className={'estate-detail-closeable-child-row'}>
                                            <div>{intl.formatMessage({ id: `${LOCALE_PREFIX}.row.title.state` })}</div>
                                            <div>{proceeding.state}</div>
                                        </div>
                                    )}
                                    {proceeding.startDate && (
                                        <div className={'estate-detail-closeable-child-row'}>
                                            <div>{intl.formatMessage({ id: `${LOCALE_PREFIX}.row.title.date` })}</div>
                                            <div>
                                                {
                                                    <Date
                                                        date={proceeding.startDate.value}
                                                        precision={PRECISION.MINUTE}
                                                    />
                                                }
                                            </div>
                                        </div>
                                    )}
                                    {!_.isEmpty(proceeding.participants) && (
                                        <div className={'estate-detail-closeable-child-row'}>
                                            <div>
                                                {intl.formatMessage({ id: `${LOCALE_PREFIX}.row.title.participants` })}
                                            </div>
                                            <div>
                                                {_.map(proceeding.participants, (participant, indexParticipant) => (
                                                    <Entity
                                                        key={`participant_${index}_${indexParticipant}`}
                                                        entity={participant}
                                                        value={`${_.get(participant, 'participant.name', '')} (${
                                                            participant.participantType
                                                        })`}
                                                        type={_.get(participant, 'participant.type', null)}
                                                        inactive={_.get(participant, 'participant.inactive', false)}
                                                        entId={_.get(participant, 'participant.id', null)}
                                                    />
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </CloseableRow>
                        </div>
                        {proceeding.startDate && (
                            <div className={'estate-detail-date'}>
                                <div className={'date-wrap'}>
                                    {proceeding.startDate && (
                                        <div className={'date-container'}>
                                            <div className={'date-text'}>
                                                {intl.formatMessage({ id: `${LOCALE_PREFIX}.date.from` })}
                                            </div>
                                            <Date date={proceeding.startDate.value} precision={PRECISION.DAY} />
                                        </div>
                                    )}
                                    {proceeding.endDate && (
                                        <div className={'date-container'}>
                                            <div className={'date-text'}>
                                                {intl.formatMessage({ id: `${LOCALE_PREFIX}.date.to` })}
                                            </div>
                                            <Date date={proceeding.endDate.value} precision={PRECISION.DAY} />
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                ))}
            </div>
        )
    }

    renderContent = () => {
        const { customData } = this.props

        const isLoading = _.get(customData, 'isLoading', false)

        if (isLoading) return <div className={'ownership-list-estate-detail-loader'} />

        return (
            <>
                {this.renderAddress()}
                {this.renderCadastreWorkplace()}
                {this.renderOtherEntries()}
                {this.renderRestrictions()}
                {this.renderProceedings()}
            </>
        )
    }

    render() {
        return <div className={'ownership-list-estate-detail'}>{this.renderContent()}</div>
    }
}
